import { render, staticRenderFns } from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=template&id=e3ca5bde&scoped=true&"
import script from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=script&lang=js&"
export * from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=script&lang=js&"
import style0 from "./PowerOfAttorneyCollectivelyByTwo.vue?vue&type=style&index=0&id=e3ca5bde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ca5bde",
  null
  
)

export default component.exports